import React, { useState, useEffect, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { validateToken, callApi } from "../../../lib/utils";
import moment, { duration } from "moment";
import axios from "axios";
import { useSelector } from "react-redux";
import "./AbnormalMotionHeader.css";
import {
  faLocationDot,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";
import CustomLoader from "../../GenericComponents/CustomLoader";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import AbnormalMotionHeader from "./AbnormalMotionHeader";
import AMeventList from "./AMeventList";
import store from "../../../reducers/store";
import "../DrillDownPage.css";

function AbnormalMotionEvent() {
  const pages = useSelector((state) => state?.appstate?.pages);
  const [searchList, setSearchList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [amEventsList, setAmeventsList] = useState([]);
  const profileData = useSelector((state) => state?.dashboard);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);

  useEffect(() => {
    if (profileData?.profileData?.id) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [perPage, currentPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  const fetchData = () => {
    let params = {
      patientId: profileData?.profileData?.id,
      eventType: 3,
      start: startDate,
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage),
    };
    setLoading(true);
    callApi(`/api/patient/events`, params, "POST")
      .then((response) => {
        if (response?.data?.data?.abnormalMotionEvents) {
          setAmeventsList(response?.data?.data?.abnormalMotionEvents);
          setSearchList(response?.data?.data?.abnormalMotionEvents);
          setPagination(response?.data?.data?.pagination?.pages);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.severityByAmplitude.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setAmeventsList(filteredList);
  };

  const exportFiles = (type) => {
    let params = {
      start: startDate,
      end: endDate,
      timezone: moment.tz.guess(),
    };
    setLoading(true);

    axios({
      method: "post",
      url: `/api/export/abnormal-motion/${profileData?.profileData?.id}/?export_type=${type}`,
      responseType: "blob",
      data: params,
    })
      .then((response) => {
        var filename = "";
        let disposition = null;

        if (Object.keys(response.headers).includes("content-disposition")) {
          disposition = response.headers["content-disposition"];
        } else if (
          Object.keys(response.headers).includes("Content-Disposition")
        ) {
          disposition = response.headers["Content-Disposition"];
        }

        // var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        let blobData = response.data;
        setLoading(false);
        fileDownload(filename, blobData, type);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const fileDownload = (filename, blobData, type) => {
    var blobURL = window.URL.createObjectURL(blobData);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute(
      "download",
      filename !== ""
        ? `${filename}`
        : type === "xlsx"
          ? "report.xlsx"
          : type === "csv" ? "report.csv" : "report.pdf"
    );

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  };

  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />
      <AbnormalMotionHeader />
      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText} showPdfExportIcon={true}
        pdfExport={() => exportFiles("pdf")} />

      <AMeventList currentPage={currentPage} perPage={perPage} amEventsList={amEventsList} />
    </div>
  );
}

export default AbnormalMotionEvent;
